import { render, staticRenderFns } from "./unificar.vue?vue&type=template&id=bdf444ce"
import script from "./unificar.ts?vue&type=script&lang=js&external"
export * from "./unificar.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdf444ce')) {
      api.createRecord('bdf444ce', component.options)
    } else {
      api.reload('bdf444ce', component.options)
    }
    module.hot.accept("./unificar.vue?vue&type=template&id=bdf444ce", function () {
      api.rerender('bdf444ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/duplicacoes/clientesDuplicados/unificar.vue"
export default component.exports